import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserState } from '../../../../shared/state/user/user.store';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { CompanyQuery } from '../../../../shared/state/company/company.query';
import { AppointmentService } from '../../../../shared/state/appointment/appointment.service';
import { filter, take } from 'rxjs/operators';
import { Appointment } from '../../../../shared/state/appointment/appointment.model';
import { AppointmentQuery } from '../../../../shared/state/appointment/appointment.query';
import { getEntityType } from '@datorama/akita';
import { AppointmentState } from '../../../../shared/state/appointment/appointment.store';
import {
    AlertController,
    ModalController,
    NavController,
    Platform,
} from '@ionic/angular';
import { LibraryService } from '../../../../core/services/library/library.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { AppointmentWizardComponent } from '../../../appointment-wizard/pages/appointment-wizard/appointment-wizard.component';
import { UserService } from '../../../../shared/state/user/user.service';
import { SettingsService } from 'src/app/shared/state/settings/settings.service';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';
import { ClinicDetailService } from 'src/app/shared/state/clinic-detail/clinic-detail.service';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { HeaderIconQuery } from '../../../../shared/state/header-icon/header-icon.query';
import { CalendarDeviceService } from '../../../../core/services/calendar-device/calendar-device.service';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { ClinicQuery } from 'src/app/shared/state/clinic/clinic.query';
import {
    AppointmentActionsDismissActions,
    AppointmentActionsModalComponent,
} from '../../components/appointment-actions-modal/appointment-actions-modal.component';

@Component({
    selector: 'app-appointment',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.scss'],
})
export class AppointmentComponent implements OnInit {
    user$: Observable<UserState>;
    companyFwaAppDisableTemp$: Observable<boolean>;
    appointments$: Observable<getEntityType<AppointmentState>[]>;
    genericKey$: Observable<number>;
    isLoadingContent;
    headerPicture$;
    headerBackground$;
    headerIcon$;
    appDelegate$: Observable<boolean>;

    /** Flowwwer template */
    clinicName$: Observable<string>;
    showBackButtonHeader$: Observable<boolean>;

    constructor(
        private userQuery: UserQuery,
        private companyQuery: CompanyQuery,
        private appointmentsService: AppointmentService,
        private appointmentQuery: AppointmentQuery,
        private alertCtrl: AlertController,
        private libraryService: LibraryService,
        private settingsQuery: SettingsQuery,
        private modalController: ModalController,
        private userService: UserService,
        private settingsService: SettingsService,
        private clinicDetailQuery: ClinicDetailQuery,
        private clinicDetailService: ClinicDetailService,
        private platform: Platform,
        private headerPictureQuery: HeaderPictureQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerIconQuery: HeaderIconQuery,
        private calendarDeviceService: CalendarDeviceService,
        private loadingService: LoadingService,
        private clinicQuery: ClinicQuery,
        private navCtrl: NavController
    ) {}

    ngOnInit(): void {
        this.headerPicture$ = this.headerPictureQuery.select('appointment');
        this.headerBackground$ = this.headerBackgroundQuery.select(
            'appointment'
        );
        this.headerIcon$ = this.headerIconQuery.select('appointment');

        this.user$ = this.userQuery.select();
        this.companyFwaAppDisableTemp$ = this.companyQuery.select(
            'fwaAppDisableTemp'
        );
        this.appointments$ = this.appointmentQuery.selectAll();
        this.genericKey$ = this.settingsQuery.select('genericKey');

        /** Puede que aquí se llegue antes de tener el usuario, por eso me tengo que suscribir a Akita a esperarlo */
        this.userQuery
            .select()
            .pipe(
                filter((params) => params.tokenId !== ''),
                take(1)
            )
            .subscribe(async (_) => {
                await this.getAppointments();
            });

        this.appDelegate$ = this.clinicDetailQuery.select('appDelegate');

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.showBackButtonHeader$ = this.settingsQuery.selectShowBackButtonHeader();
    }

    ionViewDidEnter() {
        if (this.clinicDetailQuery.openAppointmentWizard) {
            this.clinicDetailService.updateOpenAppointmentWizard(false);
            this.presentModalAppointmentWizard();
        }
    }

    async refreshAppointments(event) {
        await this.getAppointments();
        event.target.complete();
    }

    async getAppointments() {
        this.isLoadingContent = true;
        try {
            await this.appointmentsService.getAppointments();
        } catch (error) {
            this.isLoadingContent = false;
        }
        this.isLoadingContent = false;
    }
    deleteAppointment(appointment: Appointment) {
        this.showConfirmDelete(appointment);
    }

    async showConfirmDelete(appointment: Appointment) {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            header: this.libraryService.getLabel('app_action_delete'),
            message: this.libraryService.getLabel('app_sched_confirm_deletion'),
            buttons: [
                {
                    text: this.libraryService.getLabel('app_action_delete'),
                    role: 'confirm',
                    handler: () => {
                        this.deleteAppointmentConfirmed(appointment.id);
                    },
                },
                {
                    text: this.libraryService.getLabel('app_action_cancel'),
                    role: 'cancel',
                },
            ],
        });
        await alert.present();
    }

    async deleteAppointmentConfirmed(appointmentId) {
        try {
            await this.appointmentsService.deleteAppointment(appointmentId);
            await this.calendarDeviceService.deleteAppointmentToCalendarDevice(
                appointmentId
            );
        } catch (e) {
            this.getAppointments();
        }
    }

    async presentModalAppointmentWizard() {
        //TODO: Mejoramos parpadeo, comentando las lineas siguientes, ya que justo seguido hay otra llamada, entonces para hacer la
        //llamada del check, no mostramos spinner.
        //this.loadingService.updateShowSpinner(true);
        await this.checkUserCanMakesAppointment();
        //this.loadingService.updateShowSpinner(false);
        const modal = await this.modalController.create({
            component: AppointmentWizardComponent,
            cssClass: this.settingsQuery.browser
                ? 'modal-flowwwer modal-browser-appointment'
                : 'modal-flowwwer',
        });
        return await modal.present();
    }

    /** Comprueba si el usuario puede pedir citas antes de abrir el modal de cita */
    async checkUserCanMakesAppointment() {
        await this.userService.checkUserCanMakesAppointment();
    }

    /** Flowwwer template */
    //TODO: Mirar si sacar a un servicio ya que se usa en mucho sitios
    goHome(event) {
        event?.stopPropagation();
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.isPersonalized() ||
            this.clinicQuery.getValue().clinicsFound.length > 1
        ) {
            this.navCtrl.navigateBack(
                '/' +
                    (this.settingsQuery.isPersonalized()
                        ? this.settingsQuery.currentSystemKey
                        : '')
            );
        }
    }

    actionsAppointment(appointment: Appointment) {
        this.presentModalAppointmentActions(appointment);
    }

    async presentModalAppointmentActions(appointment: Appointment) {
        const modal = await this.modalController.create({
            component: AppointmentActionsModalComponent,
            breakpoints: [0, 0.8, 1],
            initialBreakpoint: 0.8,
            componentProps: {
                appointment: appointment,
            },
        });
        await modal.present();

        const { data } = await modal.onDidDismiss();
        if (data?.action === AppointmentActionsDismissActions.CANCEL) {
            this.deleteAppointmentConfirmed(appointment.id);
        }
    }
}
